<template>
    <div>
        <select v-model="$i18n.locale" @change="onChange($event)" class="text-sm border border-gray-200 rounded-md focus:outline-none">
            <option v-for="(lang, i) in langs" :key="`lang-${i}`" :value="lang">
                {{ lang }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        name: 'SelectLocale',
        data() {
            return { langs: ['en', 'it'] }
        },
        methods: {
            onChange(event) {
                localStorage.setItem('locale', event.target.value);
            }
        }
    }
</script>
<style scoped>
    .focus\:outline-none:focus {
        outline: 0px solid transparent;
        outline-offset: 0px;
    }
    select:focus {
        outline: 0px solid transparent;
        outline-offset: 0px;
        --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
        --tw-ring-offset-color: #fff;
        --tw-ring-color: #ffffff;
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
        border-color: #b0b2b6;
    }
</style>